<h1 mat-dialog-title style="color: #f44336"></h1>
<div mat-dialog-content>
  <mat-spinner style="margin: auto"></mat-spinner>
</div>
